import request from '@/utils/request';

// 支付宝支付-需要短信验证码
export const codeDlipayPay = (ip, data) => request({
  url: '/huanxinxiang-service/v1/alipay-sms-pay/',
  method: 'post',
  ipBaseURL: ip,
  data,
});

// 获取短信
export const getCode = (ip, data) => request({
  url: '/huanxinxiang-service/v1/code/',
  method: 'post',
  ipBaseURL: ip,
  data,
});
